export class RvoAnimal {
  dierGeslacht: string;
  dierHaarkleur: string;
  dierLandcode: string;
  dierLevensnummer: string;
  dierSoort: string;
  dierWerknummer: string;
  geboorteDatum: string;
  moederLandcode: string;
  moederLevensnummer: string;
  datumLaatsteMutatieDierkenmerken: string;
  verblijfPlaatsen: RVOLocation[];
}

export class RVOLocation {
  aanvoerDatumME?: string;
  meldingeenheid?: string;
}
